import { useEffect, useState } from 'react'

import type { ReportRequest } from '~/widgets/CostBomDemo/components/HeroComposer'

import { HeroReportAsk } from '~/widgets/CostBomDemo/components/HeroReportAsk'
import { COST_BOM_DEMO_STRINGS } from '~/widgets/CostBomDemo/strings'

interface HeroReportModalProps {
  /** What the visitor sent from the composer; the card is closed while null. */
  request: ReportRequest | null
  onClose: () => void
}

/**
 * Asks for an email to send the visitor's cost model to. Nothing navigates:
 * what they wrote stays on screen behind the card.
 */
export function HeroReportModal({ request, onClose }: HeroReportModalProps) {
  const [sent, setSent] = useState(false)
  const open = request !== null

  useEffect(() => {
    if (!open) return () => {}
    const onKeyDown = (e: KeyboardEvent) => {
      // A control inside the card that used this Escape marks it handled.
      if (e.key === 'Escape' && !e.defaultPrevented) onClose()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [open, onClose])

  if (!request) return null

  return (
    <div className="hero-report-modal">
      <button
        type="button"
        className="hero-report-modal__scrim"
        aria-label={COST_BOM_DEMO_STRINGS.dismiss}
        onClick={onClose}
      />
      <div className="hero-report-modal__card" role="dialog" aria-modal="true">
        <HeroReportAsk request={request} onSent={() => setSent(true)} />
        {/* Only while there is something to decline. Once the report is on its
            way the card ends on the expert offer, and the scrim dismisses. */}
        {!sent && (
          <button
            type="button"
            className="hero-report-modal__back"
            onClick={onClose}
          >
            {COST_BOM_DEMO_STRINGS.notNow}
          </button>
        )}
      </div>
    </div>
  )
}
